import script from "./Navlinks.vue?vue&type=script&setup=true&lang=js"
export * from "./Navlinks.vue?vue&type=script&setup=true&lang=js"

import "./Navlinks.vue?vue&type=style&index=0&id=746e72f8&lang=scss"

const __exports__ = script;

export default __exports__